var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProductDialog = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.5 11h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1m3.5 5.5c0 .827-.673 1.5-1.5 1.5h-5.006a.5.5 0 0 0-.354.146l-1.828 1.832-1.827-1.831a.5.5 0 0 0-.354-.147H4.5c-.827 0-1.5-.673-1.5-1.5v-10C3 5.673 3.673 5 4.5 5h15c.827 0 1.5.673 1.5 1.5zM19.5 4h-15A2.503 2.503 0 0 0 2 6.5v10C2 17.878 3.122 19 4.5 19h5.424l2.034 2.038a.5.5 0 0 0 .709.001L14.702 19H19.5c1.378 0 2.5-1.122 2.5-2.5v-10C22 5.122 20.878 4 19.5 4m-6 10h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1m4-6h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProductDialog);
export default ForwardRef;